//import _ from 'lodash';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { gridMargin } from './general';
import Checkbox from '@material-ui/core/Checkbox';
import _ from 'lodash';
import { withStyles } from '@material-ui/core/styles';

const styles = () => {
	return {
		spacing: {
			height: 30,
		},
		label: {
			fontSize: 16,
		},
	};
};

class FMPCheckbox extends PureComponent {
	render() {
		const { label, checked, value, path, onChange, md, contained, classes, disabled } = this.props;

		const _onChange = (event) => {
			onChange(event.target.checked, path);
		};

		const content = (
			<Grid item xs={12} md={md} style={gridMargin}>
				<FormControlLabel
					label={label}
					classes={{ root: classes.spacing, label: classes.label }}
					disabled={disabled}
					control={
						<Checkbox color="primary" value={value} checked={checked} onChange={_onChange} />
					}
				/>
			</Grid>
		);

		if (contained) {
			return (
				<Grid spacing={2} container>
					{content}
				</Grid>
			);
		} else {
			return content;
		}
	}
}

FMPCheckbox.propTypes = {
	label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
	value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]).isRequired,
	path: PropTypes.string.isRequired,
	checked: PropTypes.bool.isRequired,
	onChange: PropTypes.func.isRequired,
	classes: PropTypes.object,
	error: PropTypes.string,
	disabled: PropTypes.bool,
	md: PropTypes.number,
	contained: PropTypes.bool,
};

FMPCheckbox.defaultProps = {
	md: 12,
	contained: true,
};

export default _.flow([withStyles(styles)])(FMPCheckbox);
